import { render } from "./WorkloadDetailEndpoints.vue?vue&type=template&id=5725be3c&scoped=true"
import script from "./WorkloadDetailEndpoints.vue?vue&type=script&lang=js"
export * from "./WorkloadDetailEndpoints.vue?vue&type=script&lang=js"

import "./WorkloadDetailEndpoints.vue?vue&type=style&index=0&id=5725be3c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5725be3c"]])

export default __exports__